import { Integration } from '../types/integration';

export const integrations: Integration[] = [
  {
    id: 'acculynx',
    name: 'AccuLynx',
    description:
      'Connect your AccuLynx CRM to sync contacts, jobs, and photos.',
    icon: 'crm',
    imageUrl: '/images/acculynx-logo.png',
    status: 'available',
    features: [
      'Sync contacts and deals',
      'Real-time project updates',
      'Automated workflow triggers',
    ],
    setupUrl: '/settings/integrations/acculynx/setup',
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    description:
      'Connect your HubSpot CRM to sync contacts, lead statuses, and files via OAuth.',
    icon: 'crm',
    imageUrl: '/images/hubspot-logo.png',
    status: 'available',
    features: [
      'OAuth connection — no API keys needed',
      'Bi-directional contact sync',
      'Lead status and stage mapping',
      'Automatic file and photo uploads',
    ],
    setupUrl: '/settings/integrations/hubspot/setup',
  },
  {
    id: 'leap',
    name: 'Leap',
    description: 'Connect your Leap account to sync workflow stages and jobs.',
    icon: 'crm',
    imageUrl: '/images/Leap_Logo.jpg',
    status: 'available',
    features: [
      'Pull workflow stages from Leap',
      'Map to FieldInspect stages',
      'Sync jobs both ways',
    ],
    setupUrl: '/settings/integrations/leap/setup',
  },
  {
    id: 'jobnimbus',
    name: 'JobNimbus',
    description:
      'Connect FieldInspect with JobNimbus to streamline your roofing business operations.',
    icon: 'crm',
    imageUrl: '/images/jobnimbus-logo.png',
    status: 'available',
    features: [
      'Lead and opportunity tracking',
      'Project management integration',
    ],
    setupUrl: '/settings/integrations/jobnimbus/setup',
  },
  {
    id: 'eagleview',
    name: 'EagleView',
    description:
      'Connect your EagleView account to order aerial roof measurement reports.',
    icon: 'measurement',
    imageUrl: '/images/eagleview-logo.png',
    status: 'available',
    features: ['Aerial roof measurements', 'Automated report delivery'],
    setupUrl: '/settings/integrations/eagleview/setup',
  },
];
